import '../../App.css'
import { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid'
import DownloadIcon from '@mui/icons-material/Download';
import { Button } from '@mui/material';
import { SelectGenericFromTable } from '../universal/Axios';
import { HandleDownload } from '../universal/IOHelper';
import { PlayArrow, Pause, PlayCircle } from '@mui/icons-material';
import { observer } from "mobx-react"


const AudioTable = observer(() => {
    const [currentlyPlayingAudio, setCurrentlyPlayingAudio] = useState(false);
    const [audio, setAudio] = useState(new Audio())
    const [audioData, setAudioData] = useState([]);

    //breaks on 50000-100000
    useEffect(() => {
        SelectGenericFromTable("select * from audio_file limit 50000;", setAudioData)
    }, []);



    const toggleAudioPlay = (source) => {
        if (audio.src == source && currentlyPlayingAudio) {
            audio.pause();
            setCurrentlyPlayingAudio(false);
        }
        else {
            if (audio.src != source) {
                audio.src = source;
            }
            audio.play();
            setCurrentlyPlayingAudio(true)
        }
    }

    const getAudioButtonFromStatus = (file_name) => {
        if (audio.src.includes(file_name)) {
            return currentlyPlayingAudio ? <Pause /> : <PlayArrow />
        }
        return <PlayCircle />
    }

    if (audioData === undefined) {
        return (<p>loading...</p>)
    }

    const audioColumns = [
    {
        field: 'id',
        headerName: '',
        width: 130,
        renderCell: (params) => {
            return <>
                <Button
                    onClick={() => { HandleDownload(params.row.bucket, params.row.bucket_folder, params.row.name) }}
                >
                    <DownloadIcon />
                </Button>
                <Button
                    onClick={() => { toggleAudioPlay(params.row.source) }}
                >
                    {getAudioButtonFromStatus(params.row.name)}
                </Button>
            </>
        },
    },
    {
        field: 'name',
        headerName: 'Name',
        width: 320
    },
    {
        field: 'run_name',
        headerName: 'Run Name',
        width: 220
    },
    {
        field: 'bucket',
        headerName: 'Bucket',
        width: 220,
        hide: true
    },
    {
        field: 'type',
        headerName: 'Type',
        width: 220
    },
    {
        field: 'created_date',
        headerName: 'Created Date',
        width: 220
    },
    {
        field: 'created_by',
        headerName: 'Created By',
        width: 220
    },
    {
        field: 'source',
        headerName: 'Source',
        valueGetter: (params) => {
            var link = "https://storage.cloud.google.com/" + params.row.bucket + "/"
            if (params.row.bucket_folder != null) {
                link += params.row.bucket_folder + "/"
            }
            link += params.row.name
            return link
        },
        hide: true
    },
    {
        field: 'bucket_folder',
        headerName: 'Bucket Folder',
        hide: true
    }
    ];

    const audioDataRows = audioData?.filter(data => data != null).map((noiseAudio) =>
    ({   
        id: noiseAudio.id,
        name: noiseAudio.name,
        run_name: noiseAudio.run_name,
        bucket: noiseAudio.bucket,
        bucket_folder: noiseAudio.bucket_folder + "/",
        type: noiseAudio.type,
        created_date: noiseAudio.created_date,
        created_by: noiseAudio.created_by,
        source: (noiseAudio.bucket_folder == null ? "https://storage.cloud.google.com/" + noiseAudio.bucket + "/" + noiseAudio.name
            : "https://storage.cloud.google.com/" + noiseAudio.bucket + "/" + noiseAudio.bucket_folder + "/" + noiseAudio.name)
    }))

    return (
        <DataGrid
            disableSelectionOnClick
            rows={audioDataRows}
            columns={audioColumns}
            pagination={true}
            initialState={{
              sorting: {
                    sortModel: [{ field: 'created_date', sort: 'desc' }],
              },
            }}
      />
    )
});

export default AudioTable;
